import { NotifyHelper } from "../../../helpers/toast";
import { objFormEditorTypeDefine } from "../../action-types/form/IFormEditorTypeActionTypes";
import { generateActionForKey, generateActions } from "../generateActions";



export const formEditorTypeActions = {
    ...generateActions(objFormEditorTypeDefine, "FROM_EDITOR_TYPE"),
    ...generateActionForKey(objFormEditorTypeDefine, "FROM_EDITOR_TYPE",
        "LOAD_ERROR", (m: any) => NotifyHelper.Error(m)),
}
